export default "__VITE_ASSET__AEYkyvAP__"